import React, { useEffect } from 'react';
import ServicePageLayout from '../../components/Layout/ServicePageLayout';
import classes from './LegalPage.module.scss';

const LegalPageLayout = ({ title, lastUpdated, intro, documentTitle, children }) => {
  useEffect(() => {
    const previousTitle = document.title;
    if (documentTitle) {
      document.title = documentTitle;
    }
    return () => {
      document.title = previousTitle;
    };
  }, [documentTitle]);

  return (
    <ServicePageLayout>
      <div className={classes.legalPage}>
        <header className={classes.hero}>
          <div className={classes.container}>
            <span className={classes.eyebrow}>Privacy Policy</span>
            <h1 className={classes.title}>{title}</h1>
            {lastUpdated && (
              <p className={classes.lastUpdated}>Last updated: {lastUpdated}</p>
            )}
            {intro && <p className={classes.intro}>{intro}</p>}
          </div>
        </header>

        <div className={classes.container}>
          <article className={classes.content}>{children}</article>
        </div>
      </div>
    </ServicePageLayout>
  );
};

export default LegalPageLayout;
